// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__ymcsu","ttl":"styles_ttl__9bgpd","txt":"styles_txt__6wfGa","btnSec":"styles_btnSec__SNOms","red":"styles_red__4s-rA"};